import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SourcingProjectTaggingService {

  url ={
		getBaksetIdData : '/loadJsonObject?action_code=rf44cw',
		getProjectIdData : '/loadJsonObject?action_code=s1rn3u',
		saveSourcingTaggingData :'/saveJsonObject?action_code=tetir8',
		getTagModal : '/loadJsonObject?action_code=ccp8d8',
	}
  durationInSeconds= 5;

  constructor(private httpClient: HttpClient, private http:HttpClient, private _snackBar: MatSnackBar, private gtwSnackbar: GtwSnackbarService) { }


  getBaksetIdData(baseURL:string, tax_year: any,scenario:any,jcd_key:any, taggingParam:any){
		const options= {
			withCredentials: true,
			headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
		};
		const url = `${baseURL}${this.url.getBaksetIdData}`;

		const body = `tax_year=${encodeURIComponent(tax_year)}&scenario=${encodeURIComponent(scenario)}&jcd_key=${encodeURIComponent(jcd_key)}&filing_group=${encodeURIComponent(taggingParam.FILING_GROUP ?? '')}&ho_combination_key=${encodeURIComponent(taggingParam.HO_COMBINATION_KEY ?? '')}&combination_key=${encodeURIComponent(taggingParam.COMBINATION_KEY ?? '')}&acct_key=${encodeURIComponent(taggingParam.LOCAL_ACCT_KEY ?? '')}&tp_key=${encodeURIComponent(taggingParam.TP_KEY ?? '')}`;
		console.log('[SourcingService] getBaksetIdData URL:', url);
		console.log('[SourcingService] getBaksetIdData BODY:', body);
		console.log('[SourcingService] getBaksetIdData taggingParam keys:', taggingParam ? Object.keys(taggingParam) : 'NULL');

		return this.http.post(url, body, options).pipe(
			map((res:any) => {
				console.log('[SourcingService] getBaksetIdData RAW RESPONSE:', JSON.stringify(res));
				if(res.callSuccess == "1"){
				return res.jsonObject;
				}
				this.openSnackBar('Unable to fetch data.','gtw-snackbar--red');
				throwError(new Error('oops!'));
				return null;
			}
		));
	}


	getProjectIdData(baseURL:string, tax_year: any,scenario:any){
		const options= {
			withCredentials: true,
			headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
		};
		const url = `${baseURL}${this.url.getProjectIdData}`;

		const body = `tax_year=${encodeURIComponent(tax_year)}&scenario=${encodeURIComponent(scenario)}`;

		return this.http.post(url, body, options).pipe(
			map((res:any) => {
				if(res.callSuccess == "1"){
				return res.jsonObject;
				}
				this.openSnackBar('Unable to fetch data.','gtw-snackbar--red');
				throwError(new Error('oops!'));
				return null;
			}
		));
	}

	getSourceTaggingModalData(baseURL:string, tax_year: any,scenario:any,jcd_key:any, taggingParam:any){
		const options= {
			withCredentials: true,
			headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
		};
		const url = `${baseURL}${this.url.getTagModal}`;

		const params: Record<string, string> = {
			tax_year: String(tax_year),
			scenario: String(scenario),
			jcd_key: String(jcd_key),
			filing_group: String(taggingParam.FILING_GROUP ?? ''),
			ho_combination_key: String(taggingParam.HO_COMBINATION_KEY ?? ''),
			combination_key: String(taggingParam.COMBINATION_KEY ?? ''),
			acct_key: String(taggingParam.LOCAL_ACCT_KEY ?? ''),
			tp_key: String(taggingParam.TP_KEY ?? ''),
		};
		const body = Object.entries(params).map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&');

		return this.http.post(url, body, options).pipe(
			map((res:any) => {
				if(res.callSuccess == "1"){
				return res.jsonObject;
				}
				this.openSnackBar('Unable to fetch data.','gtw-snackbar--red');
				throwError(new Error('oops!'));
				return null;
			}
		));
	}

	saveSourcingTaggingData(baseURL : string, jsonData : any, tax_year: any,scenario:any,jcd_key:any,sso_id:any,baseGlobalParams: any, taggingParam:any,checkLockedObj: any) {
		const url = `${baseURL}${this.url.saveSourcingTaggingData}`;
		const options={
		  withCredentials: true
		};
	
		const data:any = {
		"tax_year":tax_year,
		"scenario":scenario,
		"jcd_key":jcd_key,
		"sso_id":sso_id,
		"filing_key": taggingParam.FILING_GROUP,
		"is_issue_key_enabled":baseGlobalParams.is_issue_key_enabled,
		"clob_data": JSON.stringify(jsonData),
		"scenarioCode":baseGlobalParams.scenarioCode,
		"checkLockedbj": checkLockedObj,
		};
	
		const formData = new FormData();
		Object.keys(data).forEach((key) => formData.append(key, data[key]));
	
		console.log('formData =', formData);
		console.log('data =', data);
	
	
		console.log('tax_year = ', formData.get("tax_year"));
		console.log('scenario = ', formData.get("scenario"));
		console.log('jcd_key = ', formData.get("jcd_key"));
		console.log('screen_key =', formData.get("screen_key"));
		console.log('sso_id =', formData.get("sso_id"));
		console.log('clob_data = ', formData.get("clob_data"));
	
	
	
		return this.http.post<any>(url, formData,options);
	  }

  openSnackBar(message: string, panelClass: string = '') {
    this.gtwSnackbar.openSnackBar(message, (panelClass || '') as any, true, this.durationInSeconds);
  }

}
